import { render } from "./BlobsBackgruond.vue?vue&type=template&id=d9240bb4"
import script from "./BlobsBackgruond.vue?vue&type=script&lang=js"
export * from "./BlobsBackgruond.vue?vue&type=script&lang=js"

import "./BlobsBackgruond.vue?vue&type=style&index=0&id=d9240bb4&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__